import { styled } from '@clickcease/cc-client-components-lib'

export const ButtonWrapper = styled('span', {
  '>a': {
    background: '$white',
    color: '$primaryColor',
    fontWeight: '$sb',
    fontSize: '$md',
    padding: 0,
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'self-end',
  },
})

export const EmptyTableStyled = styled('div', {
  height: '150px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '16px',
})

export const TableRowsWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  height: '460px',
  overflowY: 'auto',
})
